module.exports = __webpack_public_path__ + "static/media/cecile-hournau-FicbOWWbUqQ-unsplash.8e10bbf6.jpg";